import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { Root } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["as", "children", "display", "direction", "align", "justify", "gap", "gapX", "gapY", "wrap"];
var Stack = function Stack(_ref) {
  var as = _ref.as,
    children = _ref.children,
    display = _ref.display,
    direction = _ref.direction,
    align = _ref.align,
    justify = _ref.justify,
    gap = _ref.gap,
    gapX = _ref.gapX,
    gapY = _ref.gapY,
    wrap = _ref.wrap,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Root, _extends({
    as: as,
    display: display,
    direction: direction,
    align: align,
    justify: justify,
    gap: gap,
    gapX: gapX,
    gapY: gapY,
    $wrap: wrap,
    theme: theme
  }, rest), children);
};
process.env.NODE_ENV !== "production" ? Stack.propTypes = {
  /** Element to render as */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** CSS [display](https://developer.mozilla.org/en-US/docs/Web/CSS/display) property */
  display: PropTypes.string,
  /** CSS [flex-direction](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction) property */
  direction: PropTypes.string,
  /** CSS [align-items](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items)
   * property for aligning content along the cross-axis
   */
  align: PropTypes.string,
  /** CSS [justify-content](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content)
   * property for aligning content along the main axis
   */
  justify: PropTypes.string,
  /** CSS [gap](https://developer.mozilla.org/en-US/docs/Web/CSS/gap) property for spacing between children elements */
  gap: PropTypes.string,
  /** CSS [column-gap](https://developer.mozilla.org/en-US/docs/Web/CSS/column-gap)
   * property for horizontal spacing between children elements
   */
  gapX: PropTypes.string,
  /** CSS [row-gap](https://developer.mozilla.org/en-US/docs/Web/CSS/row-gap)
   * property for vertical spacing between children elements
   */
  gapY: PropTypes.string,
  /** CSS [flex-wrap](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap) property */
  wrap: PropTypes.string
} : void 0;
Stack.defaultProps = {
  as: 'div',
  display: 'flex',
  direction: 'column',
  align: 'center',
  justify: 'flex-start',
  gap: '1.5rem',
  gapX: undefined,
  gapY: undefined,
  wrap: 'wrap'
};
process.env.NODE_ENV !== "production" ? Stack.displayName = 'Stack' : void 0;
var Stack$1 = Stack;

export { Stack$1 as default };
